import * as types from '../mutation-types'
export default {
	namespaced: true,

	state: {
		systemUsers: []
	},

	actions: {
		fetchAll({ commit }) {
			return axios.get('/users').then(({ data }) => {
				commit(types.STORE_SYSTEM_USERS, data);
				return data;
			})
		},

		fetchById({ commit }, { id }) {
			return axios.get(`/users/${id}`).then(({ data }) => data)
		},
		
		create({ commit }, { fullName, userName, email, address, phone, password, passwordConfirmation, setId }) {
			return axios.post('/users/0', { fullName, userName, email, address, phone, password, passwordConfirmation, setId })
		},

		update({ commit }, { id, fullName, userName, email, address, phone, password, passwordConfirmation, setId }) {
			return axios.post(`/users/${id}`, { fullName, userName, email, address, phone, password, passwordConfirmation, setId })
		},

		changeState({ commit }, { id }) {
			return axios.put(`/users/${id}/change-status`);
		},
	},

	mutations: {
		[types.STORE_SYSTEM_USERS](state, systemUsers) {
			state.systemUsers = systemUsers;
		}
	},

	getters: {
		getSystemUserById: state => id => state.systemUsers.find(c => c.id === id)
	}
}